"use client";
import Card from "@/common/Card";
import CardSkeleton from "@/components/Skeleton/CardSkeleton";
import OfferCard from "@/components/Svg/OfferCard";
import { getSearchProducts } from "@/services/productService";
import { ProductType } from "@/types/productType";
import { useMutation } from "@tanstack/react-query";
import Link from "next/link";
import React, { useCallback, useEffect, useState } from "react";
function Offers() {
  const { isPending, mutateAsync: getProductsItem } = useMutation({
    mutationFn: getSearchProducts,
    retry: 2,
    retryDelay: 1000,
  });
  const [productData, setProductData] = useState<ProductType[]>([]);

  const getAllDiscountProducts = useCallback(async () => {
    try {
      const response = await getProductsItem({
        take: 8,
        mostDiscount: true,
      });
      if (response?.success) {
        setProductData(response?.products);
      }
    } catch (err) {
      console.log("error in fetch all data for last offers ", err);
    }
  }, [getProductsItem]);
  useEffect(() => {
    getAllDiscountProducts();
  }, [getAllDiscountProducts]);

  return (
    <>
      {productData?.length ? (
        <div className=" my-5 lg:mt-20">
          <div className="flex items-center gap-4 mx-6 lg:mx-16">
            <OfferCard className="offer-icon" />
            <h2 className="text-2xl  lg:text-3xl text-ws-gray-800 font-bold">
              تخفیف‌‌‌‌‌‌‌دار‌ها
            </h2>
          </div>
          <div className="p-5 sm:p-10  mt-10 bg-lighter-pink  flex items-center flex-col">
            {isPending ? (
              <CardSkeleton />
            ) : (
              <>
                <div className="w-full grid min-[1400px]:grid-cols-5 min-[1400px]:gap-3 xl:grid-cols-4 min-[900px]:grid-cols-3 min-[600px]:grid-cols-2 grid-cols-1 gap-10 sm:justify-between justify-center pb-5">
                  {productData?.map((product, index) => (
                    <div
                      key={index + 1}
                      className="mt-7 flex justify-center items-center"
                    >
                      <Card className="2xl:w-125" {...product} hasBuy={true} />
                    </div>
                  ))}
                </div>
                <Link
                  className=" text-ws-gray-500 mt-5 text-xl"
                  href="/offersList"
                >
                  <span className="underline underline-offset-[6px]	">
                    بیشتر
                  </span>
                </Link>
              </>
            )}
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default Offers;
